import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { AgentTemplateDetail } from './AgentTemplateDetail';
import { AgentTemplatesList } from './AgentTemplatesList';

/**
 * Router for Sales AI Agent Templates in AIDA
 * Handles routing between list and detail views
 */
export function AgentTemplatesRouter() {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<Route exact path={path} component={AgentTemplatesList} />
			<Route path={`${path}/:id`} component={AgentTemplateDetail} />
		</Switch>
	);
}
